export default "__VITE_ASSET__cec549cc__"